<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h3>Invite New User</h3>
        <button class="close-button" @click="$emit('close')">x</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="inviteUser">
          <div>
            <label for="role">User Type</label>
            <select v-model="role" id="role" required>
              <option value="sub_user_account">Sub User Account</option>
              <option value="professional_account">Professional Account</option>
            </select>
          </div>
          <div>
            <label for="first_name">FirstName</label>
            <input type="text" v-model="first_name" id="first_name" required />
          </div>
          <div>
            <label for="last_name">LastName</label>
            <input type="text" v-model="last_name" id="last_name" required />
          </div>
          <div>
            <label for="email">Email</label>
            <input type="email" v-model="email" id="email" required />
          </div>
          <div>
            <label for="phone_number">phone_number</label>
            <input type="number" v-model="phone_number" id="phone_number" required />
          </div>
          <button type="submit">Invite</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { userService } from '@/api/user.service';

export default {
  data() {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      role: '',
      email: '',
    };
  },
  methods: {
    async inviteUser() {
      try {
        const user = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          phone_number: this.phone_number,
          role: this.role,
        };
        await userService.inviteUser(user);
        this.$emit('close');
        this.$toast.success('Invitation sent successfully');
      } catch (error) {
        console.error(error);
        this.$toast.error('Failed to send invitation');
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
</style>
